import {
  container,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  boxShadow,
  drawerWidth,
  transition,
  whiteColor,
  grayColor,
  blackColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

const pagesHeaderStyle = (theme) => ({
  appBar: {
    backgroundColor: "transparent",
    boxShadow: "none",
    borderBottom: "0",
    marginBottom: "0",
    position: "absolute",
    width: "100%",
    paddingTop: "10px",
    zIndex: "1029",
    color: grayColor[6],
    border: "0",
    borderRadius: "3px",
    padding: "10px 0",
    transition: "all 150ms ease 0s",
    minHeight: "50px",
    display: "block",
  },
  container: {
    ...container,
    minHeight: "50px",
  },
  flex: {
    flex: 1,
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: whiteColor,
    letterSpacing: "unset",
    "&:hover,&:focus": {
      background: "transparent",
      color: whiteColor,
    },
  },
  appResponsive: {
    top: "8px",
  },
  primary: {
    backgroundColor: primaryColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    marginRight: "-15px",
    paddingLeft: "0",
    listStyle: "none",
    color: blackColor,
    paddingTop: "0",
    paddingBottom: "0",
  },
  listFlex: {
    //marginLeft: "10%",
    display: "flex",
    justifyContent: "flex-end", // Espacio uniforme entre columnas
    alignItems: "center", // Alinear los elementos verticalmente
    marginLeft: "25px",
  },
  listItemFlex: {
    justifyContent: "flex-end",
    flex: "1", // Cada elemento ocupa el mismo tamaño
    textAlign: "center", // Centrar el contenido dentro de la columna
    float: "right !important",
  },
  listItem: {
    backgroundColor: "#e0e0e0", // Color de fondo
    borderRadius: "10px", // Bordes redondeados
    padding: "8px 8px", // Espaciado interno
    float: "left",
    marginRight: "5px",
    marginLeft: "5px",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
  },
  navLink: {
    ...defaultFont,
    color: blackColor,
    margin: "0 5px",
    paddingTop: "5px",
    paddingBottom: "5px",
    fontSize: "12px",
    textTransform: "none",
    borderRadius: "3px",
    lineHeight: "20px",
    position: "relative",
    display: "block",
    padding: "10px 8px",
    textDecoration: "none",
    "&:hover,&:focus": {
      color: "#000",
      background: "rgba(" + hexToRgb(grayColor[17]) + ", 0.2)",
    },
  },
  listItemIcon: {
    marginTop: "-3px",
    top: "0px",
    position: "relative",
    marginRight: "3px",
    width: "20px",
    height: "20px",
    verticalAlign: "middle",
    color: "inherit",
    display: "inline-block",
  },
  listItemIconBorder: {
    borderRadius: "3px",
    border: "1px solid black",
    padding: "2px",
  },
  listItemText: {
    flex: "none",
    padding: "0",
    minWidth: "0",
    margin: 0,
    display: "inline-block",
    position: "relative",
    whiteSpace: "nowrap",
  },
  navLinkActive: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.1)",
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    ...boxShadow,
    width: drawerWidth,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "visible",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    ...transition,
    "&:before,&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      top: "0",
    },
    "&:after": {
      background: blackColor,
      opacity: ".8",
    },
  },
  sidebarButton: {
    "&,&:hover,&:focus": {
      color: whiteColor,
    },
    top: "-2px",
  },
  appBar: {
    boxShadow: "none",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#ffffff",
    padding: "10px 20px",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    width: "80%",
    [theme.breakpoints.up("md")]: {
      marginLeft: "10%",
    },
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    width: "100px",
    height: "auto",
  },
  sidebarButton: {
    marginLeft: theme.spacing(2),
    color: "#000000",
  },
  drawerPaper: {
    width: 240,
  },
  menu: {
    display: "flex",
    listStyle: "none",
    padding: 0,
    margin: 10,
    backgroundColor: "white",
  },
  menuContainer: {
    position: "absolute",
    left: "15%",
    top: "31%",
  },
  menuItem: {
    padding: "10px 20px",
    textAlign: "center",
    cursor: "pointer",
    fontWeight: "bold",
    border: "1px solid #ddd",
    transition: "background-color 0.3s ease",
    borderRadius: "10px 10px 0px 0px",
    borderBottom: "none",
    marginLeft: "3px",
  },
  activeItem: {
    backgroundColor: "#ffc107",
    borderBottom: "2px solid #e0a800",
    color: "black",
  },
  noPadding: {
    padding: "0 !important",
  },
  styleLogo: {
    boxShadow: "none",
    cursor: "pointer",
    width: "100px",
  },
  freewayLogo: {
    width: "200px",
    [theme.breakpoints.only("xs")]: {
      marginLeft: "-20px",
      width: "70px !important",
    },
    [theme.breakpoints.only("sm")]: {
      marginLeft: "-10px",
      width: "100px !important",
    },
    [theme.breakpoints.only("md")]: {
      width: "100px !important",
    },
  },
  sanbornsFreewayLogo: {
    marginLeft: "25em",
    width: "100px",
    [theme.breakpoints.only("xs")]: {
      marginLeft: "50px",
      width: "50px",
      cursor: "pointer",
    },
    [theme.breakpoints.only("sm")]: {
      marginLeft: "10em",
      width: "100px",
      cursor: "pointer",
    },
    [theme.breakpoints.only("md")]: {
      marginLeft: "10em",
      width: "100px",
      cursor: "pointer",
    },
    [theme.breakpoints.only("lg")]: {
      marginLeft: "10em",
      width: "100px",
      cursor: "pointer",
    },
  },
  menuBarButton: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "none",
        color: "black",
      },
    },
});

export default pagesHeaderStyle;
